import { cn } from '@shared/lib/utils';

import { LandingProductsGridItem } from './LandingProductsGridItem';
import type { LandingProductContent } from '../../model/content';

export type LandingProductData = LandingProductContent;

interface LandingProductsGridProps {
  products: readonly LandingProductData[];
  className?: string;
}

export const LandingProductsGrid = ({ products, className }: LandingProductsGridProps) => {
  return (
    <ul
      className={cn(
        `
          landing-container relative mt-4 grid grid-cols-3 rounded-4xl bg-background pt-8 pb-4
          shadow-lg
          sm:pt-12
          md:mt-6
          lg:mt-10 lg:px-16 lg:pt-18
          xl:mt-12 xl:gap-16
        `,
        className
      )}
    >
      {products.map((product) => (
        <LandingProductsGridItem
          key={product.title}
          badges={product.badges}
          comingSoon={product.comingSoon}
          ctaLabel={product.ctaLabel}
          ctaTo={product.ctaTo}
          description={product.description}
          enabled={product.enabled}
          image={product.image}
          subtitle={product.subtitle}
          title={product.title}
          variant={product.variant}
          video={product.video}
        />
      ))}
    </ul>
  );
};
